import { useSupport } from '../../../../../../context/support/SupportContext';
import { supportData } from '../../../../utils/supportHelpers';
import TicketListHeader from './sections/TicketListHeader';
import TicketListItem from './sections/TicketListItem';

const TicketList = () => {
  const {
    loadingTickets,
    filteredTickets,
    selectedTicketId,
    isNewTicketAction,
    handleSelectTicket
  } = useSupport();

  return (
    <div
      className={`w-full md:w-80 flex flex-col border-r border-gray-200 bg-gray-50/30 ${
        selectedTicketId || isNewTicketAction ? 'hidden md:flex' : 'flex'
      }`}
    >
      <TicketListHeader />

      <div className="flex-1 overflow-y-auto custom-scrollbar bg-white">
        {loadingTickets ? (
          <div className="flex justify-center p-10">
            <div className="animate-spin h-5 w-5 border-2 border-[#067978] border-t-transparent rounded-full" />
          </div>
        ) : filteredTickets.length === 0 ? (
          <div className="p-10 text-center text-gray-400 text-xs font-medium">
            {supportData.emptyStates.noTickets.title}
          </div>
        ) : (
          <div className="divide-y divide-gray-50">
            {filteredTickets.map((ticket) => (
              <TicketListItem
                key={ticket._id}
                ticket={ticket}
                isSelected={selectedTicketId === ticket._id}
                onSelect={handleSelectTicket}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketList;
